import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { FileMessageIcon } from "modules/icons";
import CircularIconButton from "../_shared/buttons/circular-icon-button";
import { FileGalleryFragment } from "gql/graphql";
import { useRouter } from "next/router";

import {
  FILE_GALLERY_BUTTON_BOX_SIZE,
  FILE_GALLERY_BUTTON_BACKGROUND_COLOR,
  FILE_GALLERY_BUTTON_WIDTH,
} from "modules/utils/Constants";
import { VStack, Text } from "@chakra-ui/react";
import { useOverlay } from "modules/providers/overlay-provider";
import {
  MESSAGE_THREAD_ID_QUERY_STRING,
  MESSAGE_ID_QUERY_STRING,
} from "modules/hooks/use-query-string";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  file: FileGalleryFragment;
}

const FileGalleryViewMessageButton = ({ file }: IProps) => {
  const { closeModal, closeDrawers } = useOverlay();
  const { push, query } = useRouter();

  const onNavigateToMessageClicked = useCallback(
    (file: FileGalleryFragment) => () => {
      closeModal();
      closeDrawers({ types: [DRAWER_TYPE.MESSAGE_THREAD_FILES] });
      push({
        query: {
          ...query,
          [MESSAGE_THREAD_ID_QUERY_STRING]: file.messageThreadId,
          [MESSAGE_ID_QUERY_STRING]: file.messageId,
        },
      });
    },
    [closeDrawers, closeModal, push, query],
  );

  return (
    <VStack spacing={1} w={FILE_GALLERY_BUTTON_WIDTH}>
      <CircularIconButton
        icon={
          <FileMessageIcon
            boxSize={FILE_GALLERY_BUTTON_BOX_SIZE}
            fill={colors.white}
          />
        }
        onClick={onNavigateToMessageClicked(file)}
        aria-label="message"
        backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
        variant="hover"
      />
      <Text color={colors.grayPrimary} fontWeight={500} fontSize={10}>
        View Message
      </Text>
    </VStack>
  );
};

export default memo(FileGalleryViewMessageButton);
